<template>
  <div>
    <!-- MOBILE -->
    <el-dialog v-if="$isMobile()" :class="(isMobileLandscape) ? 'mobile hm-signature-dialog' : 'hm-signature-dialog'"
      :visible.sync="dialogVisible" :show-close="isMobilePortrait" @close="closeSignature"
      width="100%" fullscreen center>
      <!-- HEADER -->
      <div v-if="isMobilePortrait" slot="title" class="hm-sign-title">
        <strong>{{$t('webdocument.msg.fooma_add_signature')}}</strong>
      </div>
      <!-- BODY -->
      <div :style="(isMobilePortrait) ? 'margin:auto;' : 'margin:auto;width:' + (canvas_width + 40) + 'px'">
        <div :style="(isMobilePortrait) ? 'padding:20px 20px 5px' : 'display:flex;padding:20px 0'">
          <!-- LANDSCAPE -->
          <div v-if="isMobileLandscape" :style="'width:30px;margin-right:10px;height:' + canvas_height + 'px'">
            <div>
              <div v-for="color in colors" :key="color"
                :style="'background-color:' + color"
                @click="penColor = color"
                :class="((color === penColor) ? 'color active-horizontal' : 'color')">
              </div>
            </div>
          </div>
          <div class="hm-editor-body">
            <div v-if="isMobilePortrait">
              <div style="display:flex;justify-content:space-between;margin-top:10px;margin-bottom:20px">
                <div style="word-break:break-word">
                  {{$t('webdocument.msg.fooma_info_touch')}}
                </div>
                <div />
                <div style="width:100px;text-align:right">
                  <el-button v-if="isMobilePortrait && !isEmpty" @click="clearSignature" size="mini" type="info">
                    {{$t('webdocument.lbl.clear')}}
                  </el-button>
                </div>
              </div>
            </div>
            <div class="hm-editor__draw" style="position:relative;border: 1px solid #9da9b3;border-radius:4px;background:#fafafa">
              <div v-if="isMobileLandscape">
                <div class="hm-control">
                  <div>
                    <el-button v-if="!isEmpty" @click="clearSignature" size="mini" type="info">
                      {{$t('webdocument.lbl.clear')}}
                    </el-button>
                  </div>
                </div>
                <div class="hm-control-bottom">
                  <div>
                    <el-button :disabled="!isEnough" size="mini" type="primary" @click="signSignature">
                      {{$t('webdocument.lbl.sign')}}
                    </el-button>
                  </div>
                </div>
              </div>
              <img style="position:absolute;top:80%;left:15%;border-bottom:1px dashed #c8c8c8;height:1px;width:70%" />
              <div @click="mouseClickDown" @touchmove="mouseClickDown">
                <vueSignature style="margin-top:0px"
                  ref="signature"
                  :sigOption="options"
                  color-format="hex"
                  :w="canvas_width + 'px'"
                  :h="canvas_height + 'px'">
                </vueSignature>
              </div>
            </div>
          </div>
          <!-- PORTRAIT -->
          <div v-if="isMobilePortrait">
            <div style="margin-top:15px;margin-bottom:30px;display:flex; justify-content:space-between;">
              <div />
              <div style="width: 100px;display:flex;gap:10px;justify-content:right">
                <div v-for="color in colors" :key="color"
                  :style="'background-color:' + color"
                  @click="penColor = color"
                  :class="((color === penColor) ? 'color active' : 'color')">
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <!-- FOOTER -->
      <div v-if="isMobilePortrait" slot="footer" class="hm-footer">
        <div style="display:flex;flex-direction:row">
          <div>
            <!-- <el-button type="info" @click="dialogVisible = false">Zrusit</el-button> -->
          </div>
          <div style="width:100%"></div>
          <div>
            <el-button :disabled="!isEnough" type="primary" @click="signSignature">
              {{$t('webdocument.lbl.sign_document')}}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- NOT MOBILE -->
    <el-dialog v-else class="hm-signature-dialog" @close="closeSignature"
      :visible.sync="dialogVisible" width="776px" center>
      <div slot="title" class="hm-sign-title">
        <strong>{{$t('webdocument.msg.fooma_add_signature')}}</strong>
      </div>
      <div>
        <div style="padding:20px 32px 10px">
          <div class="hm-editor-body">
            <div v-if="!($isMobile() && orientation() === 'landscape')" style="margin-bottom:16px; display:flex; justify-content:space-between;">
              <div>{{$t('webdocument.msg.fooma_info_pc')}}</div>
              <div style="width: 100px;display:flex;gap:10px;justify-content:right">
                <div v-for="color in colors" :key="color"
                  :style="'background-color:' + color"
                  @click="penColor = color"
                  :class="((color === penColor) ? 'color active' : 'color')">
                </div>
              </div>
            </div>
            <div class="hm-editor__draw" style="position:relative;border: 1px solid #9da9b3;border-radius:4px;background:#fafafa">
              <div v-if="!isEmpty" class="hm-control">
                <div>
                  <el-button @click="clearSignature" size="mini" type="info">
                    {{$t('webdocument.lbl.clear')}}
                  </el-button>
                </div>
              </div>
              <img style="position:absolute;top:80%;left:15%;border-bottom:1px dashed #c8c8c8;height:1px;width:70%" />
              <div @click="mouseClickDown" @touchmove="mouseClickDown">
                <vueSignature style="margin-top:0px;"
                  ref="signature"
                  :sigOption="options"
                  color-format="hex"
                  :w="canvas_width + 'px'"
                  :h="canvas_height + 'px'">
                </vueSignature>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!($isMobile() && orientation() === 'landscape')" slot="footer" class="hm-footer" :style="'margin:auto;max-width:' + (canvas_width - 20) + 'px'">
        <div style="display:flex;flex-direction:row">
          <div>
            <el-button type="info" @click="closeSignature">{{$t('webdocument.lbl.cancel')}}</el-button>
          </div>
          <div style="width:100%"></div>
          <div>
            <el-button :disabled="!isEnough" type="primary" @click="signSignature">{{$t('webdocument.lbl.sign_document')}}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueSignature from 'vue-signature'

export default {
  components: {
    vueSignature
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMobileLandscape: false,
      isMobilePortrait: false,
      minPoints: 25,
      isEmpty: true,
      isEnough: false,
      colors: ['#310d9e'], // ['#000', '#0f6fd1', '#63696e'],
      sigEl: undefined,
      dialogVisible: false,
      penColor: '#310d9e',
      options: {
        penColor: '#310d9e',
        backgroundColor: 'rgb(0,0,0,0)'
      },
      canvas_width: 726,
      canvas_height: 726 / 2.5,
      window_width: undefined,
      window_height: undefined,
      editorStyleObj: {}
    }
  },
  watch: {
    show (value) {
      console.log('signature show', value)
    },
    penColor (value) {
      this.changePenColor()
    }
  },
  created () {
    this.$i18n.locale = 'sk'
    this.dialogVisible = this.show
    console.log('isMobile', this.$isMobile(), this.show)
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener(
        'resize',
        this.handleResize
      )
    })
    this.initSignature()
  },
  methods: {
    initSignature () {
      const interval = setInterval(() => {
        if (this.$refs.signature) {
          this.sigEl = this.$refs.signature
          this.sigEl.sig.canvas.className = 'hm-canvas'
          this.sigEl.sig.minWidth = 2.0
          this.sigEl.sig.maxWidth = 2.5
          this.sigEl.sig.minWidth = (this.isMobilePortrait) ? 1.5 : 2.5
          this.sigEl.sig.maxWidth = (this.isMobilePortrait) ? 2.0 : 3
          this.handleResize()
          clearInterval(interval)
        }
      }, 50)
    },
    handleSize () {
      let totalPoints = 0
      // console.log(this.sigEl.sig.toData())
      const drawings = this.sigEl.sig.toData()
      for (var i = 0; i < drawings.length; i++) {
        totalPoints += drawings[i].points.length
      }
      this.isEnough = (totalPoints > this.minPoints)
    },
    handleResize () {
      // console.log('handleResize', window.innerWidth, window.innerHeight)
      this.window_width = window.innerWidth
      this.window_height = window.innerHeight
      this.orientation()

      if (this.$isMobile()) {
        if (this.isMobilePortrait) {
          this.canvas_width = window.innerWidth - 40
          this.canvas_height = parseFloat(this.canvas_width * 0.4).toFixed(1)
        }
        else {
          this.canvas_height = window.innerHeight - 50
          this.canvas_width = parseFloat(this.canvas_height * 2.5).toFixed(1)

          if (this.canvas_width > window.innerWidth) {
            this.canvas_width = window.innerWidth - 40
            this.canvas_height = parseFloat(this.canvas_width * 0.4).toFixed(1)
          }
        }
        this.resizeCanvas()
      }
      else {
        if (this.canvas_width !== 726) {
          this.canvas_width = 726
          this.canvas_height = this.canvas_width * 0.4
          this.resizeCanvas()
        }
      }
    },
    resizeCanvas () {
      // console.log('resizeCanvas', this.canvas_width, this.canvas_height, this.sigEl)
      if (this.sigEl) {
        this.clearSignature()
        this.sigEl.sig.canvas.width = this.canvas_width
        this.sigEl.sig.canvas.height = this.canvas_height
        this.isEmpty = true
        this.isEnough = false
        
        const interval = setInterval(() => {
          if (this.$refs.signature) {
            this.sigEl = this.$refs.signature
            this.sigEl.sig.minWidth = (this.isMobilePortrait) ? 1.5 : 2.5
            this.sigEl.sig.maxWidth = (this.isMobilePortrait) ? 2.0 : 3
            this.sigEl.sig.penColor = this.penColor
            this.sigEl.sig.options.penColor = this.penColor
            this.sigEl.sig.canvas.className = 'hm-canvas'
            clearInterval(interval)

            // var ctx = this.sigEl.sig.canvas.getContext('2d')
            // ctx.globalCompositeOperation = 'destination-over'
            // ctx.beginPath()
            // ctx.moveTo(10, 100)
            // ctx.lineTo(200, 100)
            // ctx.stroke()

            console.log(this.sigEl)
            this.handleSize()
            
          }
        }, 50)
      }
    },
    orientation () {
      if (this.$isMobile()) {
        if (window.innerWidth > window.innerHeight) {
          this.isMobileLandscape = true
          this.isMobilePortrait = false
        }
        else {
          this.isMobilePortrait = true
          this.isMobileLandscape = false
        }
      }
      return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
    },
    changePenColor () {
      if (this.sigEl) {
        this.sigEl.sig.penColor = this.penColor
        this.sigEl.sig.options.penColor = this.penColor
      }
    },
    mouseClickDown () {
      this.isEmpty = this.sigEl.isEmpty()
      this.handleSize()
    },
    clearSignature () {
      if (this.sigEl) {
        this.sigEl.clear()
        this.isEmpty = true
        this.isEnough = false
      }
    },
    undoSignature () {
      if (this.sigEl) {
        this.sigEl.undo()
      }
    },
    signSignature () {
      this.$emit('save', this.sigEl.save())
      this.dialogVisible = false
    },
    closeSignature () {
      console.log('close signature', this.show)
      this.$emit('close')
      this.dialogVisible = false
    }
  }
}
</script>

<style>
  .hm-canvas {
    position: absolute;
    z-index: 10;
  }
  .color {
    cursor: pointer;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    margin-top:5px;
  }
  .active {
    margin-top: 0px;
    height: 25px;
    width: 25px;
  }
  .active-horizontal {
    margin-top: 5px;
    height: 25px;
    width: 25px;
  }
  .el-dialog__body {
    padding: 0px !important;
  }

  .hm-control {
    position:absolute;
    top: 10px;
    right: 10px;
    z-index: 15;
  }
  .hm-control-bottom {
    position:absolute;
    bottom: 10px;
    right: 10px;
    z-index: 15;
  }

  .hm-control-line {
    position: absolute;
    bottom: 20%;
    left: 20%;
    right: 20%;
    height: 2px;
    background-color: #f1f2f4;
  }

  .hm-signature-dialog .el-button--info {
    color: #38424b;
    background-color: #e3e6e9;
    border-color: #e3e6e9;
  }
  .hm-signature-dialog .el-button--info:hover {
    background-color: #f1f2f4;
    border-color: #f1f2f4;
    color: #38424b;
  }

  .el-dialog__header {
    background-color:#f1f2f4;
    border-bottom:1px solid #e5e5e5;
    padding:20px 10px;
  }

  .mobile .el-dialog__header {
    background-color:#f1f2f4;
    border-bottom:1px solid #e5e5e5;
    padding:0px;
    height:0px;
  }

  .el-dialog__footer {
    border-top: 0px solid #e5e5e5;
  }

  .hm-sign-title {
    text-align: left;
    padding-left: 10px;
  }

  .hm-editor-body {
    box-sizing: border-box;
    /* flex-direction: column;
    justify-content: space-between; */
    max-width:726px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HMSignature/index.vue